// Dummy data index file for showcase purposes
// This file can be easily deleted once real data is available

// Export existing dummy data
export { homeBrandData } from './homeBrandData';

// Export new dummy product data
export { dummyProducts } from './productDummy';

export { getDummyProductList } from './dummyProductService';

// Original dummy data exports
export const cartItemData = [
  {
    id: '1',
    sku_id: 'ED-KCW223',
    img_url:
      'https://pwsiteimages.blob.core.windows.net/edencorp/0045224_mixsoon-bean-cream-50ml_115.jpeg',
    name: 'Mixsoon BEAN CREAM 50ML',
    unit_price: 19.3,
    quantity: 2,
    quantity_unit: 2,
  },
  {
    id: 'ED-KCW28',
    sku_id: 'ED-KCW28',
    img_url:
      'https://pwsiteimages.blob.core.windows.net/edencorp/0043986_joycook-wok-pan-cast-11_200.jpeg',
    name: '11" JOYCOOK WOK PAN CAST',
    unit_price: 15.5,
    quantity: 10,
    quantity_unit: 10,
  },
];

export const homeCategoryData = [
  {
    img: 'https://pwsiteimages.blob.core.windows.net/edencorp/0010929_new-arrivals_600.png',
    title: 'New Arrivals',
    link: '/search?category=new-arrivals',
  },
  {
    img: 'https://pwsiteimages.blob.core.windows.net/edencorp/0022758_rice-cookers_600.png',
    title: 'Rice Cookers',
    link: '/search?category=rice-cookers',
  },
  {
    img: 'https://pwsiteimages.blob.core.windows.net/edencorp/0010920_dining_600.png',
    title: 'Dining',
    link: '/search?category=dinings',
  },
  {
    img: 'https://pwsiteimages.blob.core.windows.net/edencorp/0022756_kitchen_600.png',
    title: 'Kitchen',
    link: '/search?category=kitchen',
  },
  {
    img: 'https://pwsiteimages.blob.core.windows.net/edencorp/0010919_health-beauty_600.png',
    title: 'Health & Beauty',
    link: '/search?category=health',
  },
  {
    img: 'https://pwsiteimages.blob.core.windows.net/edencorp/0010918_home-goods_600.png',
    title: 'Home Goods',
    link: '/search?category=home-goods',
  },
];

export const homeBannerData = [
  {
    src: 'https://pwsiteimages.blob.core.windows.net/edencorp/0040261_Aisan%20home%20goods_f1.jpeg',
    link: 'https://edencorp.com/section/aisan-home-goods',
  },
  {
    src: 'https://pwsiteimages.blob.core.windows.net/edencorp/0010943_joycook%20banner.png',
    link: 'https://edencorp.com/section/joycook',
  },
  {
    src: 'https://pwsiteimages.blob.core.windows.net/edencorp/0010945_cuchen%20banner.png',
    link: 'https://edencorp.com/section/cuchen',
  },
];

export const homeItemData = [
  {
    id: '10E0702',
    name: 'EDISON CHOPSTICK Pororo right-handed 7"',
    image:
      'https://pwsiteimages.blob.core.windows.net/edencorp/0032924_foot-bath-bucket-plpk-sq-13x9-12h_625.jpeg',
    inStock: true,
    srpPrice: 7.99,
    price: 4.55,
  },
  {
    id: '10E0702',
    name: 'EDISON CHOPSTICK Pororo right-handed 7"',
    image:
      'https://pwsiteimages.blob.core.windows.net/edencorp/0032924_foot-bath-bucket-plpk-sq-13x9-12h_625.jpeg',
    inStock: true,
    srpPrice: 7.99,
    price: 4.55,
  },
  {
    id: '10E0702',
    name: 'EDISON CHOPSTICK Pororo right-handed 7"',
    image:
      'https://pwsiteimages.blob.core.windows.net/edencorp/0032924_foot-bath-bucket-plpk-sq-13x9-12h_625.jpeg',
    inStock: true,
    srpPrice: 7.99,
    price: 4.55,
  },
  {
    id: '10E0702',
    name: 'EDISON CHOPSTICK Pororo right-handed 7"',
    image:
      'https://pwsiteimages.blob.core.windows.net/edencorp/0032924_foot-bath-bucket-plpk-sq-13x9-12h_625.jpeg',
    inStock: true,
    srpPrice: 7.99,
    price: 4.55,
  },
  {
    id: '10E0702',
    name: 'EDISON CHOPSTICK Pororo right-handed 7"',
    image:
      'https://pwsiteimages.blob.core.windows.net/edencorp/0032924_foot-bath-bucket-plpk-sq-13x9-12h_625.jpeg',
    inStock: true,
    srpPrice: 7.99,
    price: 4.55,
  },
  {
    id: '10E0702',
    name: 'EDISON CHOPSTICK Pororo right-handed 7"',
    image:
      'https://pwsiteimages.blob.core.windows.net/edencorp/0032924_foot-bath-bucket-plpk-sq-13x9-12h_625.jpeg',
    inStock: true,
    srpPrice: 7.99,
    price: 4.55,
  },
];

export const productData = {
  id: '10E0702',
  name: 'CUCHEN IH-PRESS RICE COOKER 10cup (wt)',
  brand: 'CUCHEN',
  sku: 'CRT-RPK1070WUS',
  description: `- 10 Cup (1.8L)\n
- Cuchens premium object design - Harmonious design that matches the surroundings, inspired by pottery.\n
- Smart Auto Keep-Warm and Reheat\n
- Preschedule When to Start Cooking\n
- The First-Ever Speedy Cooking for White Rice in 13 minutes / Multigrain Rice in 29 minutes\n
- Detachable Stainless Steel Clean Cover entirely made of x3 high strength stainless steel - provides high durability\n
- One-Touch Auto Cleaning cleanses the nozzle by distributing high-pressure steam through the nozzle\n
- Voice Notification in English, Korean, Chinese\n
- Notification of When to Replace Rubber Packing\n
- Notification of When to Initiate Auto-Cleaning\n
- Power Saving Mode\n
- Noise-Free Steam Vent\n
- 20 Safety devices\n
- Made in Korea\n
  `,
  overview: `- Superior induction heating (IH) technology\n- Healthy cooking options: brown rice and GABA brown rice settings\n- Easy-to-clean clear coated stainless steel exterior\n- Automatic keep warm and extended keep warm\n- Delay timer (2 settings)\n- Triple heater (bottom, side and lid) generate heat all around for even heating\n
- Menu settings include: white rice (regular, softer or harder), jasmine white rice, mixed rice, sushi rice, porridge, sweet rice, brown rice, GABA brown rice and quick cooking\n- cETLus listed, tested to comply with FCC standards\n- Instruction manual in English, French, Traditional Chinese, Korean, Japanese and Vietnamese`,
  srp_price: 449.99,
  price: 350,
  weight: 0.81,
  height: 8.3,
  length: 7,
  width: 5.5,
  size: '5.5 Cups',
  uom: '01/02',
  color: 'Black & Silver',
  quantity_unit: 2,
  barcode: '8809469885768',
  category_list: [
    { title: 'Home', link: '/search' },
    { title: 'Kitchen', link: '/search' },
    { title: 'Kitchen Appliance', link: '/search' },
    { title: 'Rice Cookers', link: '/search' },
  ],
  thumb_img_list: [
    'https://pwsiteimages.blob.core.windows.net/edencorp/0041235_cuchen-ih-press-rice-cooker-10cup-wt_105.jpeg',
    'https://pwsiteimages.blob.core.windows.net/edencorp/0027538_cuchen-ih-press-rice-cooker-10cup-wt_105.jpeg',
  ],
  img_list: [
    'https://pwsiteimages.blob.core.windows.net/edencorp/0041235_cuchen-ih-press-rice-cooker-10cup-wt.jpeg',
    'https://pwsiteimages.blob.core.windows.net/edencorp/0027538_cuchen-ih-press-rice-cooker-10cup-wt.jpeg',
  ],
};

export const filterData = {
  category: [
    { title: 'New Arrivals', value: 'new', amount: 1 },
    { title: 'plate', value: 'plate', amount: 6 },
  ],
  diameter: [{ title: 'Bowl 0 ~ 4 inch', value: 'under_4', amount: 1 }],
  recentlyViewed: [
    {
      id: 1,
      name: 'TIGER IH RICE COOKER 5.5CUP (Dark Gray)',
      img_url:
        'https://pwsiteimages.blob.core.windows.net/edencorp/0047472_tiger-ih-rice-cooker-55cup-dark-gray_80.jpeg',
    },
    {
      id: 2,
      name: '4"D BOWL Beige 326/096 Melamine',
      img_url:
        'https://pwsiteimages.blob.core.windows.net/edencorp/0040776_4d-bowl-bg-326096-melamine_80.jpeg',
    },
    {
      id: 3,
      name: '3-5/8"x2-1/2" 92 X 62 mm PLATE (bg tetragon) 310/090A Melamine',
      img_url:
        'https://pwsiteimages.blob.core.windows.net/edencorp/0026121_3-58x2-12-92-x-62-mm-plate-bg-tetragon-310090a-melamine_80.jpeg',
    },
  ],
};

export const searchItemData = [
  {
    id: '10E0702',
    name: 'EDISON CHOPSTICK Pororo right-handed 7"',
    image:
      'https://pwsiteimages.blob.core.windows.net/edencorp/0032924_foot-bath-bucket-plpk-sq-13x9-12h_625.jpeg',
    inStock: true,
    srpPrice: 7.99,
    unitPrice: 4.55,
  },
];

export const perPageOptions = [24, 48, 100];

export const sortOptions = [
  'Featured',
  'Newest',
  'Price Asc',
  'Price Desc',
  'Name Asc',
  'Name Desc',
  'Sku Asc',
  'Sku Desc',
  'Stock Desc',
  'Stock Asc',
  'Best Selling',
];

export const favoritesListData = [
  {
    id: 'NP-HCC10',
    sku_id: 'NP-HCC10',
    name: 'ZOJIRUSHI IH RICE COOKER MICOM 5.5CUP (XH), IH',
    img_url:
      'https://pwsiteimages.blob.core.windows.net/edencorp/0041101_zojirushi-ih-rice-cooker-micom-55cup-wt_105.jpeg',
    inStock: true,
    srp_price: 7.99,
    price: 255.5,
    totQty: 2,
    quantity_unit: 2,
  },
];
